// ─────────────────────────────────────────────────────────────────────────────
// HomePage.jsx
// ─────────────────────────────────────────────────────────────────────────────

import HeroSection    from '@components/home/HeroSection'
import WelcomeSection from '@components/home/WelcomeSection'
import NewsSection    from '@components/home/NewsSection'
import ExpertSection  from '@components/home/ExpertSection'
import PartnersSection from '@components/home/PartnersSection'
import CtaBanner from '@components/common/CtaBanner'
import SEOHead from '@components/common/SEOHead'

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Salient Agrinutrition',
  url: 'https://salientagrinutrition.com',
  logo: 'https://salientagrinutrition.com/logo.png',
  description: 'Sri Lanka\'s trusted distributor of premium animal nutrition products for poultry, dairy, and livestock.',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'LK',
  },
  sameAs: [],
}

export default function HomePage() {
  return (
    <main>
      <SEOHead
        description="Salient Agrinutrition is Sri Lanka's trusted distributor of premium animal nutrition products from MIAVIT and leading global manufacturers. Expert technical support included."
        path="/"
        jsonLd={orgSchema}
      />
      <HeroSection />
 
      <WelcomeSection />
 
      <NewsSection />
 
      <ExpertSection />
 
      <PartnersSection />
 
      <CtaBanner />
    </main>
  )
}
